import { Button, Dialog, Grid, makeStyles, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, useMediaQuery, useTheme } from '@material-ui/core';
import { Alarm } from '@material-ui/icons';
import moment from 'moment';
import React, { useContext, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { pluralizeDays, pluralizeHours, _T } from '../../../../../include/appI18n';
import { BackdropContext } from '../../../../../include/react-components/BackdropProvider';
import { formatMoney } from '../../../../../include/utils';
import '../../../../NewTourSearch/compoments/TourSearch.css';
import { useFlightConfiguration, useTourDescription } from '../../../store/TourDescriptionStore';
import './FlightVariants.css';
import { FlightVariantsDialog } from './FlightVariantsDialog';
const drawerWidth = 350;
export const useFlightVariantsStyles = makeStyles(theme => ({
    flightInfoPart: {
        fontWeight: 400,
        display: 'inline-block',
        '& > span': {
            display: 'block',
        },
        '& .time': {
            fontSize: '26px',
        },
        '& label': {
            fontWeight: 400,
        },
    },
    flightNumberAirlineInfo: {
        color: theme.palette.grey["600"],
        marginTop: 4,
    },
    flightDatetimeContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    filterPaper: {
        background: theme.palette.secondary.main,
        padding: '24px',
    },
    root: {
        display: 'flex',
    },
    toolbar: theme.mixins.toolbar,
    drawer: {
        [theme.breakpoints.up('md')]: {
            width: drawerWidth,
            flexShrink: 0,
        },
    },
    mobileToolbar: {
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    drawerPaper: {
    //width: drawerWidth,
    },
    flightSearchContent: {
        flexGrow: 1,
        '& .MuiAccordionSummary-root': {
            width: '100%',
        },
    },
    dialog: {
        overFlowY: 'overlay',
        '& .MuiDialog-paper': {
            minHeight: 'calc(100% - 64px)',
        },
    },
    selectedFlightsTable: {
        fontSize: '13px !important',
        fontWeight: 400,
        '& .MuiTableCell-root, & .MuiTableCell-head': {
            fontSize: '13px !important',
            fontWeight: 400,
        },
    },
    remainingPaymentTimeframeButton: {
        fontSize: '13px !important',
        fontWeight: 400,
    },
}));
export function FlightVariants({ flights, isFrame }) {
    var _a;
    const classes = useFlightVariantsStyles();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const spinner = useContext(BackdropContext);
    const [{ price: tourPrice, externalFlight, flightsLoading, tourDescription }, { setFlight }] = useTourDescription(null, isFrame);
    const [{ flightConfiguration }] = useFlightConfiguration(isFrame);
    const [dialogOpen, setDialogOpen] = useState(!!(tourPrice === null || tourPrice === void 0 ? void 0 : tourPrice.externalFlights) && !((_a = tourPrice === null || tourPrice === void 0 ? void 0 : tourPrice.aviacenterServices) === null || _a === void 0 ? void 0 : _a.length) && !!flightConfiguration.enabled && !!flightConfiguration.autorun);
    const remainingPaymentTimeframeText = useMemo(() => {
        if (!(externalFlight === null || externalFlight === void 0 ? void 0 : externalFlight.paymentDeadline))
            return undefined;
        const diff = Math.max(1, moment(externalFlight.paymentDeadline).diff(moment.utc()));
        const duration = moment.duration(diff);
        const hours = Math.floor(duration.asHours());
        if (hours >= 48) {
            const days = Math.floor(duration.asDays());
            return `${days} ${pluralizeDays(days)}`;
        }
        else if (hours >= 1) {
            return `${hours} ${pluralizeHours(hours)}`;
        }
        return _T.FLIGHT_SEARCH_LESS_THEN_HOUR;
    }, [externalFlight === null || externalFlight === void 0 ? void 0 : externalFlight.paymentDeadline]);
    const onClose = () => {
        if (!flightConfiguration.mandatory || externalFlight)
            setDialogOpen(false);
    };
    const dialogRef = useRef(null);
    useLayoutEffect(() => {
        if (flightsLoading)
            spinner.show();
        else
            spinner.hide();
    }, [flightsLoading]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Grid, { container: true, spacing: 2, alignItems: "center", className: classes.selectedFlightsTable },
            React.createElement(Grid, { item: true, xs: 12, className: `table-responsive` },
                React.createElement(Table, { className: `table table-condensed cart-grid mb-0` },
                    React.createElement(TableHead, null,
                        React.createElement(TableRow, { className: `` },
                            React.createElement(TableCell, { className: `col-sm-4 col-md-6` }, _T.COMMON_FLIGHT_PLANE),
                            React.createElement(TableCell, { className: `col-sm-2 col-md-3` }, _T.COMMON_TIME),
                            React.createElement(TableCell, { className: `col-sm-2 col-md-2` }, _T.FLIGHT_CLASS),
                            React.createElement(TableCell, { className: `col-sm-2 col-md-1` }, _T.COMMON_PRICE))),
                    React.createElement(TableBody, null, externalFlight ?
                        React.createElement(React.Fragment, null, [...externalFlight.forwardStops, ...(externalFlight.returnStops || [])].map((stop, index, array) => {
                            var _a;
                            return (React.createElement(TableRow, { key: index },
                                React.createElement(TableCell, null,
                                    React.createElement("label", { className: classes.flightInfoPart },
                                        React.createElement("span", null,
                                            stop.departureAirportCityName,
                                            " ",
                                            stop.departureAirportName && stop.departureAirportCode ? `(${stop.departureAirportName}, ${stop.departureAirportCode})` : null,
                                            ' - ',
                                            stop.arrivalAirportCityName,
                                            " ",
                                            stop.arrivalAirportName && stop.arrivalAirportCode ? `(${stop.arrivalAirportName}, ${stop.arrivalAirportCode})` : null),
                                        React.createElement("span", { className: classes.flightNumberAirlineInfo },
                                            _T.COMMON_FLIGHT_PLANE,
                                            ": ",
                                            stop.flightNumber,
                                            " ",
                                            stop.airlineName ? `- ${stop.airlineName}` : null))),
                                React.createElement(TableCell, null,
                                    React.createElement("label", { className: classes.flightDatetimeContainer },
                                        React.createElement("span", { className: classes.flightInfoPart },
                                            (() => {
                                                const time = moment(stop.departureTime).format('HH:mm');
                                                if (time == '00:00')
                                                    return null;
                                                return React.createElement("span", { className: "time col-12" }, time);
                                            })(),
                                            React.createElement("span", { className: "col-12" }, moment(stop.departureTime).format('L'))),
                                        React.createElement("span", { className: "mx-3" }, "-"),
                                        React.createElement("span", { className: classes.flightInfoPart },
                                            (() => {
                                                const time = moment(stop.arrivalTime).format('HH:mm');
                                                if (time == '00:00')
                                                    return null;
                                                return React.createElement("span", { className: "time col-12" }, time);
                                            })(),
                                            React.createElement("span", { className: "col-12" }, moment(stop.arrivalTime).format('L'))))),
                                React.createElement(TableCell, null,
                                    React.createElement("label", { className: classes.flightInfoPart },
                                        React.createElement("span", null,
                                            stop.airServiceClassName,
                                            " ",
                                            externalFlight.airServiceGeneralClass ? `(${externalFlight.airServiceGeneralClass})` : null),
                                        externalFlight.maxBaggageCount ?
                                            React.createElement("span", { className: classes.flightNumberAirlineInfo },
                                                _T.FLIGHT_SEARCH_BAGGAGE,
                                                ": ",
                                                externalFlight.maxBaggageCount,
                                                "x", (_a = externalFlight.maxBaggageWeight) !== null && _a !== void 0 ? _a : '?') :
                                            React.createElement("span", { className: classes.flightNumberAirlineInfo }, _T.FLIGHT_SEARCH_WITHOUT_BAGGAGE))),
                                index == 0 ?
                                    React.createElement(TableCell, { rowSpan: array.length, style: { whiteSpace: 'nowrap', verticalAlign: 'middle' } },
                                        externalFlight.flightCostDifference > 0 ? `+` : externalFlight.flightCostDifference < 0 ? `-` : ``,
                                        formatMoney(Math.abs(externalFlight.flightCostDifference), { localeAware: true, currency: tourDescription.currency.name }),
                                        externalFlight.flightCostCurrency,
                                        React.createElement("span", { className: `price-arrow-status${externalFlight.flightCostDifference > 0 ? ' up-arrow' : externalFlight.flightCostDifference < 0 ? ' down-arrow' : ''}` })) : null));
                        })) :
                        React.createElement(React.Fragment, null, flights.map((stop, index, array) => {
                            var _a, _b;
                            return (React.createElement(TableRow, { key: index },
                                React.createElement(TableCell, null,
                                    React.createElement("label", { className: classes.flightInfoPart },
                                        React.createElement("span", null,
                                            stop.cityFrom.name,
                                            ' - ',
                                            stop.cityTo.name),
                                        React.createElement("span", { className: classes.flightNumberAirlineInfo },
                                            _T.COMMON_FLIGHT_PLANE,
                                            ": ",
                                            stop.name,
                                            " ",
                                            ((_a = stop.flightClass) === null || _a === void 0 ? void 0 : _a.name) ? `- ${stop.flightClass.name}` : null))),
                                React.createElement(TableCell, null,
                                    React.createElement("label", { className: classes.flightDatetimeContainer },
                                        React.createElement("span", { className: classes.flightInfoPart },
                                            (() => {
                                                const time = moment(stop.beginDate).format('HH:mm');
                                                if (time == '00:00')
                                                    return null;
                                                return React.createElement("span", { className: "time col-12" }, time);
                                            })(),
                                            React.createElement("span", { className: "col-12" }, moment(stop.beginDate).format('L'))))),
                                React.createElement(TableCell, null,
                                    React.createElement("label", { className: classes.flightInfoPart },
                                        React.createElement("span", null, ((_b = stop.flightClass) === null || _b === void 0 ? void 0 : _b.name) ? `- ${stop.flightClass.name}` : null))),
                                React.createElement(TableCell, { style: { whiteSpace: 'nowrap', verticalAlign: 'middle' } })));
                        }))))),
            (tourPrice === null || tourPrice === void 0 ? void 0 : tourPrice.externalFlights) && flightConfiguration.enabled &&
                React.createElement(Grid, { item: true, xs: 12, container: true, justify: "space-between", alignItems: "center" },
                    React.createElement(Grid, { xs: "auto" }, externalFlight && remainingPaymentTimeframeText &&
                        React.createElement(React.Fragment, null, flightConfiguration.showExactTimeLimit ?
                            React.createElement(Tooltip, { title: `${remainingPaymentTimeframeText} ${_T.FLIGHT_SEARCH_TIMES_FOR_PAYMENT}` },
                                React.createElement(Button, { className: classes.remainingPaymentTimeframeButton, startIcon: React.createElement(Alarm, null) },
                                    _T.FLIGHT_SEARCH_PAYMENT_BEFORE,
                                    React.createElement("br", null),
                                    moment(externalFlight.paymentDeadline).format('DD.MM.YYYY HH:mm'))) :
                            React.createElement(Tooltip, { title: `${_T.FLIGHT_SEARCH_PAYMENT_AVAILABLE_BEFORE} ${moment(externalFlight.paymentDeadline).format('DD.MM.YYYY HH:mm')}` },
                                React.createElement(Button, { className: classes.remainingPaymentTimeframeButton, startIcon: React.createElement(Alarm, null) },
                                    remainingPaymentTimeframeText,
                                    React.createElement("br", null),
                                    _T.FLIGHT_SEARCH_TIMES_FOR_PAYMENT))) || null),
                    React.createElement(Grid, { xs: "auto" },
                        React.createElement(Button, { className: classes.remainingPaymentTimeframeButton, onClick: () => setDialogOpen(true), variant: 'contained', color: 'primary', fullWidth: true }, _T.FLIGHT_SEARCH_CHANGE_FLIGHTS))) || null),
        (tourPrice === null || tourPrice === void 0 ? void 0 : tourPrice.externalFlights) && flightConfiguration.enabled ?
            React.createElement(Dialog, { ref: dialogRef, disablePortal: true, open: dialogOpen, maxWidth: fullScreen ? false : "xl", fullWidth: true, fullScreen: fullScreen, scroll: 'body', onClose: onClose, className: classes.dialog, id: "flight-search-ui" },
                React.createElement(FlightVariantsDialog, { dialogRef: dialogRef, flights: flights, isFrame: isFrame, current: externalFlight, classes: classes, onClose: onClose, onFlightSelect: (f) => {
                        setFlight(f);
                        setDialogOpen(false);
                    } })) : null));
}
